<template>
    <div>
       <div class="has-text-right posRelative">
            <input class="input searchTextInput" type="text" placeholder="search discover" v-model="terms"  @keyup.enter="doSearch"/>
            <button class="button is-coolGreen is-small left-10 has-text-grey" style="z-index: 1" @click="doSearch"><i class="fa fa-search"></i></button>
            <div v-show="show" id="bundMenu" class="profileSearchMenu has-text-left" style="width: 420px; height: 500px;">
                
                <div class="profileResultItem bottom20" v-for="(item, i) in results" :key="i" @click="getBundle(item)"">
                    <!-- <img class="tinyProfileImg"  :src="item.avatarImg && item.avatarImg.substring(0,5) == 'https' ? item.avatarImg : ''" /> {{item.handle}} -->
                     <span class="is-size-5"><b><img src="@/assets/img/fourDotsLogo.png" width="15"/> {{item.listName}}</b></span><br>
                     <img class="tinyProfileImg"  :src="item.avatarImg && item.avatarImg.substring(0,5) == 'https' ? item.avatarImg : ''" /> {{item.handle}}<br>
                     <span>{{item.pubNote}}</span>
                </div>
                <div class="top10 handCursor" @click="showMore($event)"><i>show more</i></div>
            </div>
           
       </div>

        
    </div>
</template>

<script>


import { AZEventBus } from './AZEventBus'

export default{
    
    name: 'searchprofiles',
    data: function(){
        return {
            terms: '',
            show: false,
            results: [],
            offset: 0,
        }
    },

    mounted: function(){
        AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)
    },

    beforeDestroy: function(){
        AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)
    },

    methods: {
        closeAllMenusHandler: function(msg){
            this.show = false
            this.results = []   
            this.offset = 0
        },


        doSearch: function(offset){

            var self = this;

            if(!offset){
                this.offset = 0
                this.results = []
            }

            function w(d){
                self.results = self.results.concat(d)
                self.show = true
                var el = document.getElementById('bundMenu')
             
                
            }

            function n(){

            }

            this.$root.app.apiClient.post('open/confirm/pbundlesearch', {s: this.terms, offset: this.offset}, w, n)
        },

   

        showMore: function(e){
            e.stopPropagation()
            this.offset += 20
            this.doSearch(true)
        },

        getBundle: function(item){
            this.$router.push({name: 'profiledelegate', params: {propProfile: item.handle, propMCode: item.mCode, myBundle: this.$root.app.userAttrs.profile == item.handle}})
        }

    }

}

</script>

